function catItemMdl() {
	if ($('.w-cat-item-mdl').length > 0) {
		$('.w-cat-item-mdl').each(function() {
			$(this).on('click touch', function() {
				var imgPath = $(this).data('img');
				var itemData = {
					weight: $(this).parents('.cat-item').find('.cat-item__data strong').eq(0).html(),
					price: $(this).parents('.cat-item').find('.cat-item__data strong').eq(1).html()
				};
				var itemUrl = $(this).parents('.cat-item').find('.btn.btn--dark.btn--small').attr('href');
				var target = $(this).attr('data-open');
				$('#'+target).find('.mdl__standart-cake-img').css('background-image', 'url('+imgPath+')');
				$('#'+target).find('.mdl__cake-info--weight strong').html(itemData.weight);
				$('#'+target).find('.mdl__cake-info--price strong').html(itemData.price);
				$('#'+target).find('.btn.btn--light.btn--big').attr('href', itemUrl);

			});
		});
	}
}
$(document).ready(function() {
	catItemMdl();
});
